/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class FormSectionService{
        public splitFields(group: Wars.Domain.Model.FormSection) {
            var currentIndex = -1;
            var wasPreviousSplit = false;
            (<any>group).splitFields = [];
            var sortedFields = Enumerable.from(group.fields).orderBy(x => x.position).toArray();

            for (var i = 0; i < sortedFields.length; i++) {
                var field = sortedFields[i];
                if (wasPreviousSplit) {
                    var split = (<any>group).splitFields[currentIndex];
                    split.push(field);
                }
                else {
                    var item = [];
                    item.push(field);
                    (<any>group).splitFields.push(item);
                    currentIndex++;
                }

                if (field.isSplitRow) {
                    wasPreviousSplit = true;
                } else {
                    wasPreviousSplit = false;
                }
            }

            (<any>group).splitFields.forEach(s => {
                if (s.length > 1) {
                    s.forEach(f => {
                        (<any>f).isInSplitRow = true;
                    });
                }
            });
        }
    }
}
warsApp.registerService('FormSectionService', []);